import { createContext, useContext, useEffect, useRef, useState } from "react";
import { copy } from "../content/siteContent";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        try {
            return localStorage.getItem("tp-lang") === "en" ? "en" : "ar";
        } catch {
            return "ar";
        }
    });

    useEffect(() => {
        const root = document.documentElement;
        root.setAttribute("lang", lang);
        root.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
        document.title = copy[lang].meta.title;
        const meta = document.querySelector('meta[name="description"]');
        if (meta) meta.setAttribute("content", copy[lang].meta.description);
        try {
            localStorage.setItem("tp-lang", lang);
        } catch {
            /* private mode */
        }
    }, [lang]);

    const firstRender = useRef(true);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const root = document.documentElement;
        root.classList.add("lang-anim");
        const timer = setTimeout(() => root.classList.remove("lang-anim"), 550);
        return () => clearTimeout(timer);
    }, [lang]);

    const value = {
        lang,
        isRtl: lang === "ar",
        toggle: () => setLang((l) => (l === "ar" ? "en" : "ar")),
        t: copy[lang],
    };

    return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
